import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { FetchArgs } from '../../models/core';
import { Expertise, GridLookups, ProfessionsLookups, Statuses } from '../../models/offers.model';
import { OffersUserType } from 'src/app/shared/models/enums/offers.enum';
import { ListItem } from '../../models/list-item.model';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';

@Component({
    selector: 'nova-shared-offers-grid',
    templateUrl: './offers-grid.component.html',
    styleUrls: ['./offers-grid.component.scss']
})
export class SharedOffersGridComponent {
    readonly featureFlag = FeatureFlag;
    @ViewChild('grid', { static: true }) grid: GridComponent;
    @Input() gridData: GridDataResult;
    @Input() set fetchArgs(args: FetchArgs) {
        if (args) {
            this.args = args;
        }
    }
    @Input() isLoading: boolean;
    @Input() set lookups(data: GridLookups) {
        if (data) {
            this.lookupStatuses = data.statuses;
            this.lookupProfessions = data.professions;
            this.filteredStatuses = this.lookupStatuses;
            this.contractReqStatuses = data.contractRequestStatuses;
            this.accountManagerValues = data.accountManagers;
            this.contractStages = data.contractStages;
            data.expertises.forEach((exp) => {
                this.lookupExpertise.push({
                    id: exp.id,
                    name: exp.name,
                    abbreviation: exp.abbreviation,
                    sort: exp.sort,
                    professionExpertiseCodes: exp.professionExpertiseCodes,
                    searchableVal: exp.name
                });
            });
        }
    }
    @Input() rowClass: (row: RowClassArgs) => unknown = () => null;
    @Input() userType: OffersUserType;
    @Input() autoFitColumnsVal: boolean = false;
    @Input() userId: number;
    @Input() assignedToField: string;
    @Input() perPageItems: boolean;
    @Input() byId: boolean;
    @Input() hyperLinkCandidate: boolean = false;

    @Output() filterChange: EventEmitter<any> = new EventEmitter();
    @Output() gridChange: EventEmitter<any> = new EventEmitter();
    @Output() argsEmit: EventEmitter<any> = new EventEmitter();
    @Output() viewDeatilsClick: EventEmitter<number> = new EventEmitter();
    @Output() openFacilityLink: EventEmitter<number> = new EventEmitter();
    @Output() openCandidateProfile: EventEmitter<number> = new EventEmitter();
    @Output() shareOfferAsVerballyAccepted: EventEmitter<number> = new EventEmitter();

    lookupStatuses: Statuses[];
    filteredStatuses: Statuses[];
    contractReqStatuses: ListItem[];
    accountManagerValues: ListItem[];
    contractStages: ListItem[];
    lookupProfessions: ProfessionsLookups[];
    lookupExpertise: Expertise[] = [];
    offersUserType = OffersUserType;
    args: FetchArgs;

    load(args: FetchArgs) {
        this.args = args;
        this.argsEmit.emit(this.args);
    }

    isFilterValuePresent(value) {
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value;
    }

    dataGridChanged(event) {
        this.gridChange.emit(event);
    }

    filterChanged($event) {
        this.argsEmit.emit($event);
    }

    openFacility(facilityId: number) {
        this.openFacilityLink.emit(facilityId);
    }

    viewDetails(id: number) {
        this.viewDeatilsClick.emit(id);
    }

    candidateClick(candidateId: number) {
        this.openCandidateProfile.emit(candidateId);
    }

    onChangeFilter(filter) {
        this.argsEmit.emit(this.args);
    }

    verballyAcceptOffer(dataItem: any): void {
        this.shareOfferAsVerballyAccepted.emit(dataItem.id);
    }
}
